import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import Gallery from 'dibs-vg/dist/react/gallery';
import SharedContactDealerWrapper from '../../contactDealer/SharedContactDealerWrapper';

// helpers
import get from 'lodash.get';

// styles
import styles from './PdpRespHeroCarouselRequestMoreImages.scss';

export const PdpRespHeroCarouselRequestMoreImages = props => {
    const { item, user = {}, relay, disableRequestMoreImagesModal } = props;

    const contactSellerLink = (
        <a className={styles.link}>
            <FormattedMessage
                id="PdpRespHeroCarouselRequestMoreImages.contactSeller"
                defaultMessage="Contact Seller"
            />
        </a>
    );

    return (
        <div className={styles.container}>
            <Gallery className={styles.icon} />
            <div className={styles.header}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreImagesHeader"
                    defaultMessage="Want more images?"
                />
            </div>
            <div className={styles.subheader}>
                <FormattedMessage
                    id="PdpRespHeroCarouselRequestMoreImages.requestMoreImagesSubheader"
                    defaultMessage="Request additional images from the seller"
                />
            </div>
            {disableRequestMoreImagesModal ? (
                contactSellerLink
            ) : (
                <SharedContactDealerWrapper
                    item={item}
                    user={user}
                    launchOrigin="pdp image carousel"
                    modalType="REQUEST_IMAGES"
                >
                    {contactSellerLink}
                </SharedContactDealerWrapper>
            )}
        </div>
    );
};

PdpRespHeroCarouselRequestMoreImages.defaultProps = {
    disableRequestMoreImagesModal: false,
};

PdpRespHeroCarouselRequestMoreImages.propTypes = {
    disableRequestMoreImagesModal: PropTypes.bool.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    relay: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpRespHeroCarouselRequestMoreImages, {
    item: graphql`
        fragment PdpRespHeroCarouselRequestMoreImages_item on Item {
            ...SharedContactDealerWrapper_item
            serviceId
        }
    `,
    user: graphql`
        fragment PdpRespHeroCarouselRequestMoreImages_user on User {
            ...SharedContactDealerWrapper_user
            serviceId
        }
    `,
});
